import type { AuthUser } from '@/nordy/interfaces'

import { mixpanelRuntime } from './mixpanelRuntime'
import type { MixpanelProperties } from './mixpanelTypes'

function resolveCurrentUserPlan(user: AuthUser | null): string {
  if (!user) return 'unknown'

  const planName = user.subscriptionItemName ?? user.price_type
  return planName?.trim() || 'Free'
}

export function registerMixpanelLoggedInUser(user: AuthUser): void {
  const currentUserPlan = resolveCurrentUserPlan(user)
  mixpanelRuntime.identify(user._id)
  mixpanelRuntime.setPeople({ current_user_plan: currentUserPlan })
  mixpanelRuntime.register({
    is_logged_in: true,
    current_user_plan: currentUserPlan
  })
}

export function registerMixpanelAnonymousUser(
  attribution: MixpanelProperties
): void {
  mixpanelRuntime.register({
    is_logged_in: false,
    current_user_plan: 'unknown',
    ...attribution
  })
}

export function registerMixpanelLoggedOutUser(
  attribution: MixpanelProperties
): void {
  mixpanelRuntime.reset()
  registerMixpanelAnonymousUser(attribution)
}
